<div class="dialog-shell">
    <div mat-dialog-title class="dialog-header">
        <div class="header-copy">
            <h1>Gruppe ausw&auml;hlen</h1>
            <p>W&auml;hle die Zielgruppe f&uuml;r den Import aus.</p>
        </div>
        <div class="header-actions">
            <button
                *ngIf="client"
                class="add-group-btn"
                mat-mini-fab
                color="primary"
                type="button"
                aria-label="Neue Gruppe erstellen"
                matTooltip="Neue Gruppe erstellen"
                (click)="neueGruppeAnlegen()"
            >
                <mat-icon>add</mat-icon>
            </button>
            <button type="button" class="dialog-header__close" mat-icon-button aria-label="Schließen" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div mat-dialog-content class="dialog-content">
        <div class="loading-state" *ngIf="isLoading">
            <mat-hint class="hinweis-text">Lade Gruppen...</mat-hint>
        </div>

        <ng-container *ngIf="!isLoading">
            <div *ngIf="client" class="betrieb-card">
                <div class="betrieb-icon-wrap">
                    <mat-icon>home_work</mat-icon>
                </div>
                <div class="betrieb-content">
                    <div class="betrieb-label">Betrieb</div>
                    <div class="betrieb-vvvo">{{ client.vvvo }}</div>
                    <div class="betrieb-name">{{ client.bezeichnung_final }} - {{ client.zusatz_final }}</div>
                </div>
            </div>

            <div class="group-search" *ngIf="gruppen?.length > 0">
                <mat-icon>search</mat-icon>
                <input
                    type="text"
                    [(ngModel)]="searchQuery"
                    placeholder="Gruppe, Stall oder Tiere suchen"
                    aria-label="Gruppen suchen"
                />
            </div>

            <div class="groups-list" *ngIf="filteredGruppen.length > 0">
                <div class="groups-list__head" aria-hidden="true">
                    <span>Gruppe</span>
                    <span>Standort</span>
                    <span>Tiere</span>
                    <span></span>
                </div>

                <article
                    class="group-card"
                    *ngFor="let g of filteredGruppen"
                    role="button"
                    tabindex="0"
                    (click)="hinzufuegen(g)"
                    (keydown.enter)="hinzufuegen(g)"
                    (keydown.space)="hinzufuegen(g); $event.preventDefault()"
                >
                    <div class="group-card__body">
                        <div class="group-name">{{ g.bezeichnung }}</div>
                        <div class="group-stall">{{ getGruppeMeta(g) || '—' }}</div>
                        <div class="group-count">
                            <span class="group-count-value">{{ g.anzahl_tiere_aktuell ?? 0 }}</span>
                            <span class="group-count-label">Tiere aktuell</span>
                        </div>
                    </div>
                    <mat-icon class="group-card__chevron" aria-hidden="true">chevron_right</mat-icon>
                </article>
            </div>

            <div class="empty-state" *ngIf="gruppen?.length === 0">Noch keine Gruppen angelegt.</div>
            <div class="empty-state" *ngIf="gruppen?.length > 0 && filteredGruppen.length === 0">
                Keine Gruppe passend zur Suche gefunden.
            </div>
        </ng-container>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button type="button" (click)="close()">Abbrechen</button>
    </div>
</div>
